module.exports = __webpack_public_path__ + "static/media/trashBinIcon.a0a333c3.svg";